<template>
  <div class="dates-picker">
    <div class="ant-select ant-select-enabled" @click="initMonthCalendar">
      <div role="combobox" class="ant-select-selection ant-select-selection--multiple">
        <div class="ant-select-selection__rendered">
          <div class="ant-select-selection__placeholder" v-if="confirmSelectedDates.length===0">请选择日期</div>
          <ul v-else>
            <li class="ant-select-selection__choice" style="user-select: none;" v-for="item in confirmSelectedDates" :key="item">
              <div class="ant-select-selection__choice__content">
                {{item}}
              </div>
              <span class="ant-select-selection__choice__remove" @click.stop="deleteDate(item)">
                <i aria-label="图标: close" class="ant-select-remove-icon anticon anticon-close">
                  <svg viewBox="64 64 896 896" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="">
                    <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
                  </svg>
                </i>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="ant-calendar dates-picker-panel" v-if="showCalendar">
      <div class="ant-calendar-panel">
        <div tabindex="0" class="ant-calendar-date-panel">
          <div class="ant-calendar-header">
            <div style="position: relative;">
              <a role="button" title="上一年 (Control键加左方向键)" class="ant-calendar-prev-year-btn" @click="setCalendar(-1,'year');"></a>
              <a role="button" title="上个月 (翻页上键)" class="ant-calendar-prev-month-btn" @click="setCalendar(-1,'month');"></a>
              <span class="ant-calendar-ym-select">
                <a role="button" title="选择年份" class="ant-calendar-year-select" @click="whenSelectYear(currentYear)">{{currentYear}}年</a>
                <a role="button" title="选择月份" class="ant-calendar-month-select" @click="whenSelectMonth(currentMonth)">{{currentMonth+1}}月</a>
              </span>
              <a title="下个月 (翻页下键)" class="ant-calendar-next-month-btn" @click="setCalendar(1,'month');"></a>
              <a title="下一年 (Control键加右方向键)" class="ant-calendar-next-year-btn" @click="setCalendar(1,'year');"></a>
            </div>
            <div class="ant-calendar-month-panel" v-if="when==='month'">
              <div>
                <div class="ant-calendar-month-panel-header">
                  <a role="button" title="上一年 (Control键加左方向键)" class="ant-calendar-month-panel-prev-year-btn" @click="currentYear=currentYear-1"></a>
                  <a role="button" title="选择年份" class="ant-calendar-month-panel-year-select">
                    <span class="ant-calendar-month-panel-year-select-content" @click="whenSelectYear(currentYear)">{{currentYear}}</span>
                    <span class="ant-calendar-month-panel-year-select-arrow">x</span>
                  </a>
                  <a role="button" title="下一年 (Control键加右方向键)" class="ant-calendar-month-panel-next-year-btn" @click="currentYear=currentYear+1"></a>
                </div>
                <div class="ant-calendar-month-panel-body">
                  <table cellspacing="0" role="grid" class="ant-calendar-month-panel-table">
                    <tbody class="ant-calendar-month-panel-tbody">
                      <tr role="row" v-for="(item,index) in month" :key="index">
                        <td role="gridcell" v-for="child in item" :key="child.key" :title="child.name" class="ant-calendar-month-panel-cell" :class="currentMonth===child.key?'ant-calendar-month-panel-selected-cell ant-calendar-month-panel-current-cell':''" @click="onSelectMonth(child)">
                          <a class="ant-calendar-month-panel-month">{{child.name}}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="ant-calendar-year-panel" v-if="when==='year'">
              <div>
                <div class="ant-calendar-year-panel-header">
                  <a role="button" title="上一年代" class="ant-calendar-year-panel-prev-decade-btn" @click="setSelectedDecade(currentYear-10)"></a>
                  <a role="button" title="选择年代" class="ant-calendar-year-panel-decade-select">
                    <span class="ant-calendar-year-panel-decade-select-content">{{currentDecadeStart}}-{{currentDecadeStart+9}}</span>
                    <span class="ant-calendar-year-panel-decade-select-arrow">x</span>
                  </a>
                  <a role="button" title="下一年代" class="ant-calendar-year-panel-next-decade-btn" @click="setSelectedDecade(currentYear+10)"></a>
                </div>
                <div class="ant-calendar-year-panel-body">
                  <table cellspacing="0" role="grid" class="ant-calendar-year-panel-table">
                    <tbody class="ant-calendar-year-panel-tbody">
                      <tr role="row" v-for="(item,index) in currentDecade" :key="index">
                        <td role="gridcell" v-for="child in item" :key="child.year" :title="child.year" class="ant-calendar-year-panel-cell " :class="{'ant-calendar-year-panel-last-decade-cell':child.isLast || child.isNext,'ant-calendar-year-panel-selected-cell':child.year===currentYear}" @click="onSelectYear(child)">
                          <a class="ant-calendar-year-panel-year">{{child.year}}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="ant-calendar-body">
            <table cellspacing="0" role="grid" class="ant-calendar-table">
              <thead>
                <tr role="row">
                  <th role="columnheader" title="周一" class="ant-calendar-column-header">
                    <span class="ant-calendar-column-header-inner">一</span>
                  </th>
                  <th role="columnheader" title="周二" class="ant-calendar-column-header">
                    <span class="ant-calendar-column-header-inner">二</span>
                  </th>
                  <th role="columnheader" title="周三" class="ant-calendar-column-header">
                    <span class="ant-calendar-column-header-inner">三</span>
                  </th>
                  <th role="columnheader" title="周四" class="ant-calendar-column-header">
                    <span class="ant-calendar-column-header-inner">四</span>
                  </th>
                  <th role="columnheader" title="周五" class="ant-calendar-column-header">
                    <span class="ant-calendar-column-header-inner">五</span>
                  </th>
                  <th role="columnheader" title="周六" class="ant-calendar-column-header">
                    <span class="ant-calendar-column-header-inner">六</span>
                  </th>
                  <th role="columnheader" title="周日" class="ant-calendar-column-header">
                    <span class="ant-calendar-column-header-inner">日</span>
                  </th>
                </tr>
              </thead>
              <tbody class="ant-calendar-tbody">
                <tr role="row" class="" v-for="(item,index) in currentCalendarDate" :key="index">
                  <td role="gridcell" v-for="child in item" :key="child.formatFullDay" :title="child.formatFullDay" class="ant-calendar-cell" :class="{'ant-calendar-last-month-cell':child.isLastMonth,'ant-calendar-next-month-btn-day':child.isNextMonth,
                  'ant-calendar-today':child.isCurrentDay,
                  'ant-calendar-selected-date':selectedDates.indexOf(child.formatFullDay)!==-1,
                  'ant-calendar-disabled-cell':child.atDisabledRange,}" @click="onSelectDay(child)">
                    <div class="ant-calendar-date">{{child.day}}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="ant-calendar-footer">
            <span class="ant-calendar-footer-btn" style="text-align:right;">
              <a-button type="link" @click="selectToday">今天</a-button>
              <a role="button" class="ant-calendar-ok-btn" @click="selectConfirm">确 定</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import LayoutConfig from '../utils/LayoutConfig.js';
import { initMonthCalendar } from '../utils/tools.js';

export default {
  components: {},
  props: {
    selectResult: Array,
    config: Object,
    maxDate: Object,
  },
  data() {
    return {
      showCalendar: false,
      month: [
        [
          { name: '一月', key: 0 },
          { name: '二月', key: 1 },
          { name: '三月', key: 2 },
        ],
        [
          { name: '四月', key: 3 },
          { name: '五月', key: 4 },
          { name: '六月', key: 5 },
        ],
        [
          { name: '七月', key: 6 },
          { name: '八月', key: 7 },
          { name: '九月', key: 8 },
        ],
        [
          { name: '十月', key: 9 },
          { name: '十一月', key: 10 },
          { name: '十二月', key: 11 },
        ],
      ],
      selectedDates: _.cloneDeep(this.selectResult), // 选择的多日期数据
      confirmSelectedDates: [],
      currentDate: undefined,
      currentMonth: undefined,
      currentYear: undefined,
      currentDecadeStart: undefined,
      currentDecade: [],
      currentCalendarDate: [],
      when: 'date',
    };
  },
  computed: {},
  methods: {
    //根据选中的年份设置选中年所在的十年期
    setSelectedDecade(currentYear) {
      this.currentYear = currentYear;
      const yearStr = currentYear.toString();
      const currentDecade = `${yearStr.substring(0, 3)}0`;
      this.currentDecadeStart = Number(currentDecade);
      let decadeInfo = [];
      for (
        var i = Number(currentDecade) - 1;
        i <= Number(currentDecade) + 10;
        i++
      ) {
        let year = {
          year: i,
        };
        if (i === Number(currentDecade) - 1) year.isLast = true;
        if (i === Number(currentDecade) + 10) year.isNext = true;
        decadeInfo.push(year);
      }
      let lineNum =
        decadeInfo.length % 3 === 0
          ? decadeInfo.length / 3
          : Math.floor(decadeInfo.length / 3 + 1);
      let res = [];
      for (let i = 0; i < lineNum; i++) {
        let temp = decadeInfo.slice(i * 3, i * 3 + 3);
        res.push(temp);
      }
      this.currentDecade = res;
    },
    whenSelectYear(currentYear) {
      this.when = 'year';
    },
    whenSelectMonth(currentMonth) {
      this.when = 'month';
    },
    onSelectYear(yearInfo) {
      if (yearInfo.isLast) this.setSelectedDecade(this.currentYear - 10);
      if (yearInfo.isNext) this.setSelectedDecade(this.currentYear + 10);
      if (!yearInfo.isLast && !yearInfo.isNext) {
        this.currentYear = yearInfo.year;
        this.when = 'month';
        this.currentDate = moment(this.currentDate).year(yearInfo.year);
      }
    },
    onSelectMonth(monthInfo) {
      this.currentMonth = monthInfo.key;
      this.when = 'date';
      this.currentDate = moment(this.currentDate).month(monthInfo.key);
      this.currentCalendarDate = initMonthCalendar(
        this.currentDate,
        this.maxDate,
      );
    },
    onSelectDay(dayInfo) {
      if (dayInfo.atDisabledRange) return;
      if (this.selectedDates.indexOf(dayInfo.formatFullDay) === -1) {
        this.selectedDates.push(dayInfo.formatFullDay);
      } else {
        this.selectedDates.splice(
          this.selectedDates.indexOf(dayInfo.formatFullDay),
          1,
        );
      }
    },
    setCalendar(num, type) {
      this.currentDate = moment(this.currentDate).add(num, type);
      this.currentYear = moment(this.currentDate).year();
      this.currentMonth = moment(this.currentDate).month();
      this.currentCalendarDate = initMonthCalendar(this.currentDate);
    },
    selectToday() {
      if (this.selectedDates.indexOf(moment().format('YYYY-MM-DD')) === -1) {
        this.selectedDates.push(moment().format('YYYY-MM-DD'));
      }
      this.currentDate = moment().format('YYYY-MM');
      this.currentYear = moment(this.currentDate).year();
      this.currentMonth = moment(this.currentDate).month();
      this.currentCalendarDate = initMonthCalendar(this.currentDate);
      this.setSelectedDecade(this.currentYear);
    },
    selectConfirm() {
      this.confirmSelectedDates = _.cloneDeep(this.selectedDates);
      this.showCalendar = false;
      this.$emit('get-multidate', this.confirmSelectedDates);
    },
    initMonthCalendar() {
      this.currentDate = this.selectedDates // 当前时间面板选中的日期
        ? moment(this.selectedDates[this.selectedDates.length - 1]).format(
            'YYYY-MM',
          )
        : moment().format('YYYY-MM');
      this.currentYear = moment(this.currentDate).year();
      this.currentMonth = moment(this.currentDate).month();
      this.currentCalendarDate = initMonthCalendar(
        this.currentDate,
        this.maxDate,
      );
      this.setSelectedDecade(this.currentYear);
      this.showCalendar = true;
    },
    deleteDate(date) {
      this.selectedDates.splice(this.selectedDates.indexOf(date), 1);
      this.confirmSelectedDates = _.cloneDeep(this.selectedDates);
      this.$emit('get-multidate', this.confirmSelectedDates);
    },
  },
  created() {},

  watch: {
    selectResult: {
      handler(val) {
        this.selectedDates = _.cloneDeep(val);
        this.confirmSelectedDates = _.cloneDeep(val);
      },
      deep: true,
    },
  },
};
</script>

<style lang="less">
.dates-picker {
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial,
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  .ant-input:focus {
    outline: none;
  }
  &-panel {
    position: absolute;
    bottom: -325px;
    left: 0;
    z-index: 1050;
    min-width: 278px;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum';
    margin-bottom: 10px;
  }

  &-calendar {
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #fff;
    border-radius: 4px;
    outline: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    &-header {
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid #e8e8e8;
    }
  }
  .ant-calendar-date-panel:focus {
    outline: none;
  }
}
.dates-picker:focus {
  outline: none;
}
</style>
